__turbopack_context__.v({
  "accessibilityStatementBanner": "_0dGhW_accessibilityStatementBanner",
  "calloutSection": "_0dGhW_calloutSection",
  "contactModal": "_0dGhW_contactModal",
  "footer": "_0dGhW_footer",
  "header": "_0dGhW_header",
  "root": "_0dGhW_root",
});
